"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var CoreStyle = exports.CoreStyle = {
	g: {
		transitions: {
			duration: "500ms",
			heroDelay: "50ms"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/libcomponents/core-style.js
 ** module id = 92
 ** module chunks = 0
 **/